import { render } from "./StickyCartSlider.vue?vue&type=template&id=0b84d650"
import script from "./StickyCartSlider.vue?vue&type=script&lang=js"
export * from "./StickyCartSlider.vue?vue&type=script&lang=js"

import "./StickyCartSlider.vue?vue&type=style&index=0&id=0b84d650&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__